module.exports = __webpack_public_path__ + "img/google.09a3bb83.png";